import React, { useEffect, useState } from "react";
// import KassaList from "./KassaList";
import YukXatiHeader from "../../Components/YukXati/YukXatiHeader";
import { IoIosAddCircleOutline } from "react-icons/io";
import { Button } from "antd";
import { useMessage } from "../../Components/MessageProvider/MessageProvider";
import axiosInstance from "../../Components/axiosInstance/AxiosInstance";
import KassaAdd from "./KassaAdd";
import KassaList from "./KassaList";
import { Link } from "react-router-dom";
import { AiOutlineDelete } from "react-icons/ai";
import { LiaEdit } from "react-icons/lia";
import KassaEdit from "./KassaEdit";

export default function Kassa() {
  let [loading, setLoading] = useState(false);
  let [selected, setSelected] = useState([]);
  const messageApi = useMessage();
  let [isModalAddOpen, setIsModalAddOpen] = useState(false);
  let [info, setInfo] = useState(null);
  let [openEdit, setOpenEdit] = useState(false);
  let getKassa = async () => {
    try {
      setLoading(true);

      let { data } = await axiosInstance.get("/api/kassa");

      if (data.success) {
        console.log("data");
        console.log(data);
        setInfo(data.data);
      }
    } catch (error) {
      if (error?.response?.data?.error) {
        messageApi.open({
          type: "warning",
          content: error?.response?.data?.message,
        });
      } else {
        messageApi.open({
          type: "warning",
          content: error.message,
        });
      }
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const handleDeletion = async () => {
    try {
      let { data } = await axiosInstance.delete(
        "/api/kassa/" + selected[0]?.id
      );

      if (data.success) {
        setSelected([]);
        setInfo([
          ...info.map((el) => {
            return {
              ...el,
              selected: false,
            };
          }),
        ]);
        getKassa();
      }
      console.log(info);
    } catch (error) {
      if (error?.response?.data?.error) {
        messageApi.open({
          type: "warning",
          content: error?.response?.data?.message,
        });
      } else {
        messageApi.open({
          type: "warning",
          content: error.message,
        });
      }
    }
  };

  useEffect(() => {
    getKassa();
  }, []);

  if (info?.length == 0 || !info) {
    return (
      <div>
        <YukXatiHeader PageTitle={"Kassa"} />
        <Button
          onClick={() => {
            setIsModalAddOpen(true);
          }}
          icon={<IoIosAddCircleOutline />}
          size="large"
          className=" rounded-xl fixed bottom-[5%] right-[2%] z-30 bg-white"
        ></Button>
        <KassaAdd
          getData={getKassa}
          setIsModalOpen={setIsModalAddOpen}
          isModalOpen={isModalAddOpen}
        />

        <main class="grid  place-items-center bg-white px-6 py-24 sm:py-32 lg:px-8">
          <div class="text-center">
            {/* <p class="text-base font-semibold text-indigo-600">404</p>
                  <h1 class="mt-4 text-balance text-5xl font-semibold tracking-tight text-gray-900 sm:text-7xl">
                    Page not found
                  </h1> */}
            <p class="mt-6 text-pretty text-lg font-medium text-gray-500 sm:text-xl/8">
              Tarix mavjud emas
            </p>
            {/* <div class="mt-10 flex items-center justify-center gap-x-6">
              <Link
                to="/tickets"
                class="rounded-md bg-indigo-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
              >
                Tiketlar
              </Link>
              <Link
                to="/tickets/kirim"
                class="text-sm font-semibold text-gray-900"
              >
                Kirimlar <span aria-hidden="true">&rarr;</span>
              </Link>
            </div> */}
          </div>
        </main>
      </div>
    );
  }

  return (
    <div>
      <KassaAdd
        getData={getKassa}
        setIsModalOpen={setIsModalAddOpen}
        isModalOpen={isModalAddOpen}
      />
      <KassaEdit
        isModalOpen={openEdit}
        setIsModalOpen={setOpenEdit}
        getData={getKassa}
        info={selected.length > 0 ? selected[0] : {}}
      />
      <YukXatiHeader PageTitle={"Kassa"} />
      {selected.length > 0 ? (
        <div className="fixed top-0 left-0 w-[100%] bg-[#fff] h-[45px]  ">
          <div className="max-w-[900px] w-[100%] h-[100%] m-auto flex flex-row items-center justify-end border-b-[1px] gap-2 border-[#bfbfbf] shadow-sm">
            {selected.length === 1 ? (
              <Button icon={<AiOutlineDelete />} onClick={handleDeletion} />
            ) : null}
            {selected.length === 1 ? (
              <Button
                onClick={() => {
                  setOpenEdit(true);
                }}
                icon={<LiaEdit />}
              />
            ) : null}
          </div>
        </div>
      ) : null}

      <Button
        onClick={() => {
          setIsModalAddOpen(true);
        }}
        icon={<IoIosAddCircleOutline />}
        size="large"
        className=" rounded-xl fixed bottom-[5%] right-[2%] z-30 bg-white"
      ></Button>
      <div className="max-w-[900px] w-[100%] overflow-auto m-auto flex flex-col items-start gap-2 pb-[300px]">
        {info
          ? info.map((el) => {
              return (
                <KassaList
                  el={el}
                  setSelected={setSelected}
                  selected={selected}
                  setData={setInfo}
                  data={info}
                />
              );
            })
          : null}
      </div>
    </div>
  );
}
